export default __webpack_public_path__ + "static/media/0x51869836681bce74a514625c856afb697a013797.d9110784.webp";